import { DASHBOARD_ROUTES } from './DashboardLayout.constant';
import { DashboardLayoutNavItem } from './DashboardLayoutNavItem';
import { BottomNavBar, BottomNavItem } from '@design-system/BottomNavBar';

const renderedBottomNavRoutes = DASHBOARD_ROUTES.map((route) => (
  <li key={route.label} className="flex-1"> 
    <BottomNavItem asChild>
      <DashboardLayoutNavItem
        to={route.to}
        icon={route.icon}
        label={route.label}
        activeIcon={route.activeIcon}
        className="[&_span]:typography-footnote"
      />
    </BottomNavItem>
  </li>
));

export const DashboardLayoutBottomNavBar = () => {
  return (
    <BottomNavBar className="fixed bottom-0 md:hidden w-full">
      <ul className="w-full flex flex-row justify-between items-center px-4"> 
        {renderedBottomNavRoutes}
      </ul>
    </BottomNavBar>
  );
};